const inAppUpdateCheck = async () => {
  return null;
}

export default inAppUpdateCheck
